import 'semantic-ui-less/definitions/elements/flag.less';import _default from './Flag';
export { _default as default };